// Define image URLs for use throughout the site
export const images = {
  // Main logos
  lotusLogo: '/lotus-sport-logo.jpg',
  exereyesLogo: '/exereyes_logo.jpg',
  
  // App Screenshots
  appScreenshot1: '/Ana Sayfa (3).png',
  appScreenshot2: '/Antrenman 2 (1).png',
  appScreenshot3: '/Rapor (1).png',
  

  // Exercise Photos
  exerciseWaterBottle: '/sise_biceps_curl.png',
  exerciseBackpack:   '/canta_squad.png',
  exerciseChair: '/sandalye_triceps.png',


  // Features section
  featureAI: '/Antrenman 2 (1).png',
  featureHealth: '/Rapor (1).png',
  featureExercise: '/Rapor (1).png',
  
  // App Interface Screenshots
  appInterface1: '/Antrenman 2 (1).png',
  appInterface2: '/Antrenman 2 (1).png',
  appInterface3: '/Hedef Seçimi (1).png',
  appInterface4: '/Rapor (1).png',
  
  // About section
  officeImage: '/Ana Sayfa (3).png',
  teamImage: 'https://images.pexels.com/photos/3182812/pexels-photo-3182812.jpeg',
  
  // Testimonials
  personPlaceholder1: 'https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg',
  personPlaceholder2: 'https://images.pexels.com/photos/1181424/pexels-photo-1181424.jpeg',
};